/**
 * Aligne automatiquement le wrapper Trailer+Breadcrumb avec la largeur de l'image
 * Et le déplace dans le bon conteneur (modal-opener)
 */

(function() {
  'use strict';
  
  function setupWrapper() {
    const wrapper = document.querySelector('.custom-trailer-breadcrumb-wrapper');
    const modalOpener = document.querySelector('modal-opener.product__modal-opener, .product__modal-opener');
    
    if (!wrapper) {
      console.warn('Wrapper not found');
      return;
    }
    
    if (!modalOpener) {
      console.warn('Modal opener not found');
      return;
    }
    
    // Déplacer le wrapper DANS le modal-opener
    if (wrapper.parentElement !== modalOpener) {
      console.log('✅ Moving wrapper into modal-opener');
      modalOpener.appendChild(wrapper);
    }
    
    console.log('✅ Wrapper positioned correctly in modal-opener');
  }
  
  // Exécuter dès que le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupWrapper);
  } else {
    setupWrapper();
  }
})();